export const LEASE_PERMISSIONS = {
  LIST: 'lease-list',
  CREATE: 'lease-create',
  VIEW: 'lease-view',
  EDIT: 'lease-edit',
  DELETE: 'lease-delete',
  PERMANENT_DELETE: 'lease-permanent-delete',
  RESTORE: 'lease-restore',
  EXPORT: 'lease-export',
};

export const LEASE_LIST_ACCESS = [
  LEASE_PERMISSIONS.LIST,
  LEASE_PERMISSIONS.CREATE,
  LEASE_PERMISSIONS.VIEW,
  LEASE_PERMISSIONS.EDIT,
  LEASE_PERMISSIONS.DELETE,
  LEASE_PERMISSIONS.PERMANENT_DELETE,
  LEASE_PERMISSIONS.RESTORE,
  LEASE_PERMISSIONS.EXPORT,
];

export const LEASE_VIEW_ACCESS = [
  LEASE_PERMISSIONS.VIEW,
  LEASE_PERMISSIONS.LIST,
  LEASE_PERMISSIONS.EDIT,
];
